/* @flow */

import React, { PureComponent } from 'react'
import type { ChildrenArray, Node } from 'react'

type ButtonPropsType = {
  type: string, // submit, reset, button
  action: (any) => void,
  className?: string,
  disabled: boolean,
  loading?: boolean,
  tabIndex?: number,
  children?: ChildrenArray<Node> | Node,
  arrow?: boolean
}

class Button extends PureComponent<ButtonPropsType> {
  static defaultProps = {
    type: 'button',
    disabled: false,
    arrow: false
  }

  clickHandler = (event: SyntheticEvent<any>) => {
    event.preventDefault()
    this.props.action(event)
  }

  render(): React$Element<*> {
    const { type, loading, className, disabled, tabIndex, arrow, children } = this.props
    const cn = [
      'atp-btn',
      `atp-btn--${type == 'submit' ? 'primary' : 'default'}`,
      arrow ? (type == 'submit' ? 'atp-btn--arrow-right' : 'atp-btn--arrow-left') : null,
      loading ? 'atp-btn--loading' : null
    ]
      .concat(className)
      .filter(Boolean)
      .join(' ')
    return (
      <button type={type} className={cn} onClick={this.clickHandler} disabled={disabled} tabIndex={tabIndex}>
        {children}
      </button>
    )
  }
}

export default Button
